import React, { Component } from 'react';
import { connect } from 'react-redux';
import App from 'components/App';
import { initUserData } from 'actions/app';

export class AppContainer extends Component {
  UNSAFE_componentWillMount() {
    const { initUserData } = this.props;
    initUserData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.onUserDataInit && !this.props.onUserDataInit) {
      // Поскольку это довольно ресурсоемкая функция нельзя ее вызывать в render
      // если onUserDataInit просто false
      this.hideSplash();
    }
  }

  hideSplash = () => {
    document.querySelector('body').classList.remove('on-load');
  };

  render() {
    const { onUserDataInit } = this.props;

    if (onUserDataInit) return null;

    return <App {...this.props} />;
  }
}

const mapStateToProps = ({ app: { onUserDataInit } }) => ({
  onUserDataInit,
});

export const mapDispatchToProps = { initUserData };

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer);
